import queryString from "query-string";

function parse(search) {
  return queryString.parse(search, { arrayFormat: "none" });
}

function stringify(params) {
  return queryString.stringify(params, { arrayFormat: "none" });
}

export { parse, stringify };
